import api from '@/api/axios';

const user = JSON.parse(localStorage.getItem('user'));

const state = {
  token: localStorage.getItem('access_token') || null,
  user: user || null,
  isLoading: false,
  error: null,
};

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token;
    if (token) {
      localStorage.setItem('access_token', token);
      console.log('Token set in localStorage:', token)
    } else {
      localStorage.removeItem('access_token');
      console.log('Token removed from localStorage')
    }
  },
  SET_USER(state, user) {
    state.user = user;
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    } else {
      localStorage.removeItem('user');
    }
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

const actions = {
  async login({ commit }, { username, password }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    
    try {
      const formData = new URLSearchParams();
      formData.append('username', username);
      formData.append('password', password);
      const response = await api.post('/api/v1/auth/token', formData, {
      // const response = await axios.post(`/api/v1/auth/token`, formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
      const { user_pid , access_token, token_type, user_name, user_id  } = response.data;
      console.log(response.data)
      console.log(token_type)
      const user = {
        pid : user_pid,
        name: user_name,
        id: user_id
      };
      commit('SET_TOKEN', access_token);
      commit('SET_USER', user);
      console.log('user info')
      console.log(response.data)
    } catch (error) {
      const errorMessage = error.response?.data?.detail || 'An error occurred during login';
      commit('SET_ERROR', errorMessage);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async logout({ commit }) {
    try {
      //await axios.post(`${API_BASE_URL}/api/v1/auth/logout`, null, {
      await api.post(`/api/v1/auth/logout`, null, {
        headers: {
          Authorization: `Bearer ${state.token}`
        }
      });
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      commit('SET_TOKEN', null);
      commit('SET_USER', null);
    }
  },
};

const getters = {
  isAuthenticated: state => !!state.token,
  currentUser: state => state.user,
  token: state => state.token,
  isAdmin: state => state.user && (state.user.pid === 383 || state.user.pid === 373), // 특정 사용자 ID가 관리자
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
